<template>
    <div id="container" type="vrenttoown">
        <div class="page page-vrenttoown"  v-ga:request="{pageType:'vrenttoown', state: {}}" v-ga:page="{pageType:glb.pageType, glb: glb, state: {}}">
            <mvtHeader />
            <div class="inline welcome large bg-brand">
                <div class="grid gap-3 fixed fixed-max-sm middle xs-grid-cols-1">
                    <h1 class="f3 text-bold"> Home Ownership With Rent-to-Own  </h1>
                    <div>
                        Known credit issues or not enough for a down payment ? Work with us and find the right partner to help you on your path towards homeownership.
                    </div>


                    <form  v-submit="show3rdPartyForm">
                        <div class="input large right input-geo">

                                <input
                                    ref="zipcode"
                                    type="text"
                                    name="zipcode"
                                    v-model="zipcode"
                                    v-validate="'required|zipcode'"
                                    maxlength="5"
                                    placeholder="ZIP Code"
                                />

                            <button class="btn primary regular"  type="submit">Apply Now</button>
                        </div>
                    </form>
                </div>
            </div>

            <div class="static-section">
                <div class="static-gs gs-sm-2 gs-md-3">
                    <div class="wrap-xs">
                        <b class="f3 text-bold">How it Works</b>
                    </div>
                    <div class="card">
                        <div>STEP 1</div>
                        <div><b class="f4">Submit your application.</b></div>
                        <div class="body">Find out if you are prequalified for a rent-to-own program - it only takes a few minutes to apply.</div>
                    </div>
                    <div class="card">
                        <div>STEP 2</div>
                        <div><b class="f4">Find the right home for you.</b></div>
                        <div class="body">Start searching for the home that fits your needs and work with an agent who's knowledgeable in rent-to-own programs.</div>
                    </div>
                    <div class="card wrap-sm">
                        <div>STEP 3</div>
                        <div><b class="f4">Homeownership</b></div>
                        <div class="body">Rent the home as you build your credit and save for a down payment.</div>
                    </div>
                </div>
            </div>

            <mortgageTools :id="glb.pageType"></mortgageTools>

            <div class="static-section" v-if="tag">
                <div class="static-gs">
                    <h2 class="f3 text-bold">
                       Related Articles
                    </h2>
                    <mvtArticle :tag="tag"/>
                </div>
            </div>
            <mvtFooter />
        </div>
        <mvtDialogCenter></mvtDialogCenter>
    </div>
</template>

<script src="./page-renttoown.js"></script>